import { render, staticRenderFns } from "./myList.vue?vue&type=template&id=3b386106&scoped=true&"
import script from "./myList.vue?vue&type=script&lang=js&"
export * from "./myList.vue?vue&type=script&lang=js&"
import style0 from "./myList.vue?vue&type=style&index=0&id=3b386106&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b386106",
  null
  
)

export default component.exports